/* tslint:disable */
/* eslint-disable */
/**
 * Flash Sale API
 * Endpoints to fetch and subscribe to published sales, claim deals and get user claim context
 *
 * The version of the OpenAPI document: v0p13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * @type Action
 * @export
 */
export type Action = { Action: 'CarsAirportSearchLink' } & CarsAirportSearchLink | { Action: 'CarsCoordinatesSearchLink' } & CarsCoordinatesSearchLink | { Action: 'ClaimOffer' } & ClaimOffer | { Action: 'DeepLink' } & DeepLink | { Action: 'HomeSearchLink' } & HomeSearchLink | { Action: 'HotelSearchLink' } & HotelSearchLink | { Action: 'PageLink' } & PageLink | { Action: 'SpecificHotelLink' } & SpecificHotelLink | { Action: 'WebLink' } & WebLink;

export const ActionEnum = {
    CarsAirportSearchLink: 'CarsAirportSearchLink',
    CarsCoordinatesSearchLink: 'CarsCoordinatesSearchLink',
    ClaimOffer: 'ClaimOffer',
    DeepLink: 'DeepLink',
    HomeSearchLink: 'HomeSearchLink',
    HotelSearchLink: 'HotelSearchLink',
    PageLink: 'PageLink',
    SpecificHotelLink: 'SpecificHotelLink',
    WebLink: 'WebLink'
} as const;

export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];


export interface ActiveCountdown {
    'HeaderTrailingElement': HeaderTrailingElementEnum;
}


export interface ActiveTimeline {
    'start': string;
    'end': string;
    'presaleStartDate': string;
}
export interface Carousel {
    'CollectionType': CollectionTypeEnum;
}


export interface CarsAirportSearchLink {
    'airportRegion': string;
    'filters': Array<string>;
    'Action': ActionEnum;
}


export interface CarsCoordinatesSearchLink {
    'centerCoordinates': Coordinates;
    'filters': Array<string>;
    'Action': ActionEnum;
}


export interface Claim {
    'offerId': OfferId;
    'voucherExpiresAt': string;
    'id': ClaimId;
    'voucherId': VoucherId;
    'saleId': FlashSaleId;
    'userId': string;
}
export interface ClaimId {
    'value': string;
}
export interface ClaimOffer {
    'offerId': string;
    'redeemAction': Action;
    'Action': ActionEnum;
}


/**
 * @type ClaimOfferErrorKind
 * @export
 */
export type ClaimOfferErrorKind = { ClaimOfferErrorKind: 'DestinationNotFound' } & DestinationNotFound | { ClaimOfferErrorKind: 'OfferAlreadyClaimed' } & OfferAlreadyClaimed | { ClaimOfferErrorKind: 'OfferCreationFailed' } & OfferCreationFailed | { ClaimOfferErrorKind: 'OfferNotFound' } & OfferNotFound | { ClaimOfferErrorKind: 'OffersNotFound' } & OffersNotFound | { ClaimOfferErrorKind: 'SaleNotFound' } & SaleNotFound;

export const ClaimOfferErrorKindEnum = {
    DestinationNotFound: 'DestinationNotFound',
    OfferAlreadyClaimed: 'OfferAlreadyClaimed',
    OfferCreationFailed: 'OfferCreationFailed',
    OfferNotFound: 'OfferNotFound',
    OffersNotFound: 'OffersNotFound',
    SaleNotFound: 'SaleNotFound'
} as const;

export type ClaimOfferErrorKindEnum = typeof ClaimOfferErrorKindEnum[keyof typeof ClaimOfferErrorKindEnum];


export interface ClaimOfferRequest {
    'offerId': OfferId;
    'saleId': FlashSaleId;
}
/**
 * @type ClaimOfferResponse
 * @export
 */
export type ClaimOfferResponse = { ClaimOfferResponse: 'Error' } & ModelError | { ClaimOfferResponse: 'Success' } & Success;

export const ClaimOfferResponseEnum = {
    Error: 'Error',
    Success: 'Success'
} as const;

export type ClaimOfferResponseEnum = typeof ClaimOfferResponseEnum[keyof typeof ClaimOfferResponseEnum];


export interface ClaimableDetails {
    'offerIds': Array<OfferId>;
}
export interface Collection {
    'header'?: CollectionHeader;
    'belowCta'?: CollectionCTA;
    'contentItemIds': Array<string>;
    'displayType': CollectionType;
}
export interface CollectionCTA {
    'title': string;
    'action': Action;
}
export interface CollectionHeader {
    'title': string;
    'subtitle'?: string;
    'leadingImage'?: string;
    'trailingElement'?: HeaderTrailingElement;
}
/**
 * @type CollectionType
 * @export
 */
export type CollectionType = { CollectionType: 'Carousel' } & Carousel | { CollectionType: 'Grid' } & Grid;

export const CollectionTypeEnum = {
    Carousel: 'Carousel',
    Grid: 'Grid'
} as const;

export type CollectionTypeEnum = typeof CollectionTypeEnum[keyof typeof CollectionTypeEnum];


export interface ContentItem {
    'subtitle'?: string;
    'claimableDetails'?: ClaimableDetails;
    'treatment'?: ContentItemTreatment;
    'image': string;
    'tags': Array<TagId>;
    'id': string;
    'displayPlatforms': Array<Platform>;
    'title': string;
    'discount'?: Discount;
    'action'?: Action;
}


export interface ContentItemMap {
    'items': { [key: string]: ContentItem; };
}
export const ContentItemTreatment = {
    Destination: 'Destination',
    FeaturedHotel: 'FeaturedHotel',
    SpecialDeal: 'SpecialDeal'
} as const;

export type ContentItemTreatment = typeof ContentItemTreatment[keyof typeof ContentItemTreatment];


export interface Coordinates {
    'latitude': number;
    'longitude': number;
}
export interface DeepLink {
    'appUrl': string;
    'Action': ActionEnum;
}


export interface DestinationBanner {
    'claimableDetails'?: ClaimableDetails;
    'style': DestinationBannerStyle;
    'kind'?: DestinationBannerKind;
    'title': string;
    'discount'?: Discount;
    'imageUrl'?: string;
    'action': Action;
}


export const DestinationBannerKind = {
    CarRental: 'CarRental',
    Dmo: 'Dmo',
    Flight: 'Flight',
    Home: 'Home',
    Hotel: 'Hotel'
} as const;

export type DestinationBannerKind = typeof DestinationBannerKind[keyof typeof DestinationBannerKind];


export const DestinationBannerStyle = {
    Dark: 'Dark',
    Light: 'Light'
} as const;

export type DestinationBannerStyle = typeof DestinationBannerStyle[keyof typeof DestinationBannerStyle];


export interface DestinationNotFound {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface DestinationPage {
    'heroImage': string;
    'destinationName': string;
    'destinationBanners': Array<DestinationBanner>;
    'PageType': PageTypeEnum;
}


export interface Discount {
    'amount': number;
    'stringVal'?: string;
    'max'?: number;
    'kind': DiscountKind;
    'presaleAmount'?: number;
}


export const DiscountKind = {
    Flat: 'Flat',
    Percentage: 'Percentage'
} as const;

export type DiscountKind = typeof DiscountKind[keyof typeof DiscountKind];


export interface FeaturedHotelsPage {
    'PageType': PageTypeEnum;
}


export interface FlashSale {
    'heroImage': string;
    'activeTimeline': ActiveTimeline;
    'insertedCollections': Array<Collection>;
    'tagGroups': Array<TagGroup>;
    'pages': Array<Page>;
    'mainCollection': Collection;
    'id': FlashSaleId;
    'contentItemsMap': ContentItemMap;
    'metadata': FlashSaleMetadata;
}
export interface FlashSaleId {
    'value': string;
}
export interface FlashSaleMetadata {
    'saleSubscriptionBonus': number;
}
export interface FunnelInfo {
    'activeTimeline': ActiveTimeline;
    'hotelListBanner'?: HotelListBanner;
}
export interface GetPublishedFlashSaleResponse {
    'sale'?: FlashSale;
}
export interface GetSaleFunnelInfoResponse {
    'info'?: FunnelInfo;
}
export interface GetUserSaleContextResponse {
    'claims': Array<Claim>;
    'subscribedToSaleAt'?: string;
}
export interface Grid {
    'CollectionType': CollectionTypeEnum;
}


/**
 * @type HeaderTrailingElement
 * @export
 */
export type HeaderTrailingElement = { HeaderTrailingElement: 'ActiveCountdown' } & ActiveCountdown | { HeaderTrailingElement: 'Image' } & Image;

export const HeaderTrailingElementEnum = {
    ActiveCountdown: 'ActiveCountdown',
    Image: 'Image'
} as const;

export type HeaderTrailingElementEnum = typeof HeaderTrailingElementEnum[keyof typeof HeaderTrailingElementEnum];


export interface HomeSearchLink {
    'centerCoordinates': Coordinates;
    'radiusKm': number;
    'marketName': string;
    'Action': ActionEnum;
}


export interface HotelListBanner {
    'isClaimed': boolean;
    'backgroundImage': string;
    'sponsor'?: Sponsor;
    'destinationName': string;
    'saleName': string;
    'discount': Discount;
    'action': Action;
}
export interface HotelSearchLink {
    'airportCode': string;
    'marketName': string;
    'radiusKm': number;
    'centerCoordinates': Coordinates;
    'Action': ActionEnum;
}


export interface Image {
    'image': string;
    'HeaderTrailingElement': HeaderTrailingElementEnum;
}


export interface ModelError {
    'error': ClaimOfferErrorKind;
    'ClaimOfferResponse': ClaimOfferResponseEnum;
}


export interface OfferAlreadyClaimed {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface OfferCreationFailed {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface OfferId {
    'value': string;
}
export interface OfferNotFound {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface OffersNotFound {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface Page {
    'id': PageId;
    'activeTimeline': ActiveTimeline;
    'contentItemIds': Array<string>;
    'pageType': PageType;
}
export interface PageId {
    'value': string;
}
export interface PageLink {
    'pageId': PageId;
    'Action': ActionEnum;
}


/**
 * @type PageType
 * @export
 */
export type PageType = { PageType: 'DestinationPage' } & DestinationPage | { PageType: 'FeaturedHotelsPage' } & FeaturedHotelsPage;

export const PageTypeEnum = {
    DestinationPage: 'DestinationPage',
    FeaturedHotelsPage: 'FeaturedHotelsPage'
} as const;

export type PageTypeEnum = typeof PageTypeEnum[keyof typeof PageTypeEnum];


export const Platform = {
    Android: 'Android',
    Ios: 'Ios',
    Web: 'Web'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];


export interface SaleNotFound {
    'ClaimOfferErrorKind': ClaimOfferErrorKindEnum;
}


export interface SpecificHotelLink {
    'lodgingId': string;
    'Action': ActionEnum;
}


export interface Sponsor {
    'id': string;
    'imageUrl': string;
    'trackingName': string;
}
export interface SubscribeToSaleRequest {
    'saleId': FlashSaleId;
}
export interface SubscribeUserToSaleResponse {
    'subscription': UserSaleSubscription;
}
export interface Success {
    'claim': Claim;
    'ClaimOfferResponse': ClaimOfferResponseEnum;
}


export interface Tag {
    'subtitle'?: string;
    'icon'?: string;
    'id': TagId;
    'title': string;
    'displayTitle'?: string;
}
export interface TagGroup {
    'tags': Array<Tag>;
    'showInPresale': boolean;
}
export interface TagId {
    'value': string;
}
export interface UserSaleSubscription {
    'updatedAt': string;
    'id': string;
    'saleId': FlashSaleId;
    'createdAt': string;
    'userId': string;
}
export interface VoucherId {
    'value': string;
}
export interface WebLink {
    'url': string;
    'Action': ActionEnum;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        apiV0FlashSaleOffersClaimPost: async (claimOfferRequest: ClaimOfferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'claimOfferRequest' is not null or undefined
            assertParamExists('apiV0FlashSaleOffersClaimPost', 'claimOfferRequest', claimOfferRequest)
            const localVarPath = `/api/v0/flashSale/offers/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        apiV0FlashSalePublishedSaleGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/flashSale/publishedSale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        apiV0FlashSalePublishedSaleSubscribePost: async (subscribeToSaleRequest: SubscribeToSaleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeToSaleRequest' is not null or undefined
            assertParamExists('apiV0FlashSalePublishedSaleSubscribePost', 'subscribeToSaleRequest', subscribeToSaleRequest)
            const localVarPath = `/api/v0/flashSale/publishedSale/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeToSaleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        apiV0FlashSaleUserContextGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/flashSale/user/context`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        apiV0FlashSaleUserSaleFunnelGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/flashSale/user/saleFunnel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        async apiV0FlashSaleOffersClaimPost(claimOfferRequest: ClaimOfferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlashSaleOffersClaimPost(claimOfferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlashSaleOffersClaimPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async apiV0FlashSalePublishedSaleGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPublishedFlashSaleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlashSalePublishedSaleGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlashSalePublishedSaleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest: SubscribeToSaleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscribeUserToSaleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlashSalePublishedSaleSubscribePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async apiV0FlashSaleUserContextGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserSaleContextResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlashSaleUserContextGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlashSaleUserContextGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        async apiV0FlashSaleUserSaleFunnelGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSaleFunnelInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FlashSaleUserSaleFunnelGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0FlashSaleUserSaleFunnelGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        apiV0FlashSaleOffersClaimPost(claimOfferRequest: ClaimOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClaimOfferResponse> {
            return localVarFp.apiV0FlashSaleOffersClaimPost(claimOfferRequest, options).then((request) => request(axios, basePath));
        },
        apiV0FlashSalePublishedSaleGet(options?: RawAxiosRequestConfig): AxiosPromise<GetPublishedFlashSaleResponse> {
            return localVarFp.apiV0FlashSalePublishedSaleGet(options).then((request) => request(axios, basePath));
        },
        apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest: SubscribeToSaleRequest, options?: RawAxiosRequestConfig): AxiosPromise<SubscribeUserToSaleResponse> {
            return localVarFp.apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest, options).then((request) => request(axios, basePath));
        },
        apiV0FlashSaleUserContextGet(options?: RawAxiosRequestConfig): AxiosPromise<GetUserSaleContextResponse> {
            return localVarFp.apiV0FlashSaleUserContextGet(options).then((request) => request(axios, basePath));
        },
        apiV0FlashSaleUserSaleFunnelGet(options?: RawAxiosRequestConfig): AxiosPromise<GetSaleFunnelInfoResponse> {
            return localVarFp.apiV0FlashSaleUserSaleFunnelGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    public apiV0FlashSaleOffersClaimPost(claimOfferRequest: ClaimOfferRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlashSaleOffersClaimPost(claimOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    public apiV0FlashSalePublishedSaleGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlashSalePublishedSaleGet(options).then((request) => request(this.axios, this.basePath));
    }

    public apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest: SubscribeToSaleRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlashSalePublishedSaleSubscribePost(subscribeToSaleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    public apiV0FlashSaleUserContextGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlashSaleUserContextGet(options).then((request) => request(this.axios, this.basePath));
    }

    public apiV0FlashSaleUserSaleFunnelGet(options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0FlashSaleUserSaleFunnelGet(options).then((request) => request(this.axios, this.basePath));
    }
}



